import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewTablero_Alertas = () => import('./Index.vue')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'tablero_alertas',
        name: 'tablero_alertas',
        component: ViewTablero_Alertas,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router